import React from "react";
import { ReactComponent as ErrorIcon } from "../images/error.svg";
const ErrorMessages = (props) => {
  const { errorMessage } = props;

  return (
    <div className="errorBox" style={{ width: props.width }}>
      <div className="errorIconContainer">
        <ErrorIcon className="errorIcon" />
      </div>
      <div className="errorMessage">{errorMessage}</div>
    </div>
  );
};

export default ErrorMessages;
